var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"pa-2"},[_c('v-col',{attrs:{"cols":"3"}},[_c('v-skeleton-loader',{attrs:{"type":"table-cell, divider, table-cell, divider, table-cell"}})],1),_c('v-col',[_c('v-skeleton-loader',{attrs:{"type":"table-cell,divider,table-cell, divider, table-cell"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }